/* eslint-disable react-hooks/exhaustive-deps */
import { Link, Outlet } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { BsPlusLg } from 'react-icons/bs';
import ReactPaginate from 'react-paginate';

import Box from 'components/ui/box';
import { useAuth } from 'context/AuthContext';
import InputMask from 'react-input-mask';
import { useState, useEffect, useRef } from 'react';
import { getUserByPrefixo } from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { TbSearch } from 'react-icons/tb';

import './styles.scss';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { RedeDetail } from './components/detail';

export default function Rede() {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [showDetail, setShowDetail] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const resultRef = useRef<HTMLDivElement>(null);

  const [mask] = useState('');

  const searchRef = useRef<any>();

  const [loadingList, setLoadingList] = useState(true);

  const { user, userInfo } = useAuth();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const getAriaLabel = (pageIndex: number, selected: boolean) => {
    return selected ? `Página ${pageIndex + 1} selecionada` : `Ir para a página ${pageIndex + 1}`;
  };

  useEffect(() => {
    const pageLinks = document.querySelectorAll('.page-link');
    pageLinks.forEach((link, index) => {
      link.setAttribute('aria-label', getAriaLabel(index, link.classList.contains('active')));
    });
  });

  async function loadData(e?: any, itemPage?: number) {
    if (!!!user?._id || !!!userInfo) return;

    if (e) {
      e.preventDefault();
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setLoadingList(true);
      setList([]);

      const homeSection = document.getElementById('main-body');
      if (homeSection) {
        homeSection.scrollTop = 0;
      }

      const data = await getUserByPrefixo(userInfo.prefixo, searchRef.current.value, rangeItem);

      setPage(data.range.pages);
      setList(data.result);

      setLoadingList(false);

      if (resultRef.current) {
        resultRef.current.focus();
      }
    } catch (e) {
      setLoadingList(false);
    }
  }

  useEffect(() => {
    if (isMounted) {
      if (!!userInfo) {
        loadData();
      }
    } else {
      setIsMounted(true);
    }
  }, [userInfo]);

  if (showDetail) return <RedeDetail onClose={() => setShowDetail('')} id={showDetail} />;

  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        <div className=" mb-3 lg:mb-10 flex justify-between items-center">
          <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
            <div>
              <Link to="../" tabIndex={-1}>
                <button className="rounded-full bg-purple flex justify-center items-center p-1" aria-label="Voltar">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>

            <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full" tabIndex={0}>
              Rede JogaJunto
            </h1>
          </div>
        </div>

        <div className="lg:flex items-stretch jusfity-between space-y-4 lg:space-y-0 lg:space-x-4 mb-12">
          <div
            className="border-2 border-electric-blue rounded-3xl px-8 py-12 bg-oxford-blue flex flex-col items-center justify-center text-center lg:w-full"
            tabIndex={0}
          >
            <p className="text-dandelion text-xl font-semibold block mb-3">Rede da Transparência Joga Junto BB</p>
            <p className="text-white text-lg font-light m-0">
              Aqui você pode visualizar os reconhecimentos recebidos{!user?.extra.rede && ' e as Realizações Destaque'} dos seus
              colegas!
            </p>
          </div>
        </div>

        <div className="mb-5 lg:flex items-center justify-between">
          <p className="text-lg mb-4 lg:mb-0">Você está visualizando a lista de profissionais da rede Joga Junto.</p>

          <div className="space-x-4 flex flex-row items-center justify-between">
            <form onSubmit={e => loadData(e)} className="pl-1 -ml-1 flex-1">
              <InputMask
                placeholder="Pesquise em toda Rede Joga Junto por nome, nome de guerra, matrícula ou prefixo"
                alwaysShowMask={false}
                mask={mask}
                ref={(ref: any) => {
                  searchRef.current = ref;
                }}
                inputMode="search"
                style={{ fontSize: 16 }}
                className="min-w-full lg:min-w-[650px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
              />
            </form>

            <TbSearch
              size={28}
              className="cursor-pointer hover:ring-2 mr-1 rounded-full"
              onClick={() => loadData(null)}
              tabIndex={0}
              aria-label="Buscar funcionário"
            />
          </div>
        </div>

        <div>
          <Box>
            <div ref={resultRef} tabIndex={-1}>
              <div className="space-y-5 lg:p-3">
                {loadingList && (
                  <div className="space-y-2">
                    <ArticlePlaceholder />
                    <ArticlePlaceholder />
                  </div>
                )}

                {!loadingList && list?.length === 0 && (
                  <div className="text-center" tabIndex={0}>
                    <h3 className="text-xl">Nenhum resultado encontrado</h3>
                  </div>
                )}

                <div className="space-y-2">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {list?.map((item: any) => (
                      <div
                        className="bg-maastricht-blue rounded-xl text-white space-y-2 cursor-pointer hover:ring-2 overflow-hidden"
                        key={item?._id}
                        onClick={() => handleDetail(item.matricula)}
                        tabIndex={0}
                        aria-label={`${item.nome} - ${item.diretoria} - ${item.funcao} - ${item.matricula}`}
                      >
                        <div className="px-4">
                          <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                            <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                              {!!item.avatar_type &&
                                (item?.image?.medium?.url ? (
                                  <img src={item.image.medium.url} alt={item.nome} className="w-full h-full" />
                                ) : (
                                  item.nome[0]
                                ))}
                              {!item.avatar_type &&
                                (!!item.avatar ? <Avatar className="w-full h-full" {...item.avatar} /> : item.nome[0])}
                            </div>
                          </div>
                        </div>

                        <div className="bg-prussian-blue-3 w-full h-full text-center pb-7 pt-5 ">
                          <div className="font-bold">
                            {item.nome_guerra} - {item.matricula}
                          </div>
                          <span className="font-thin">{item.nome} </span>
                          <div className="mt-0">
                            <span className="text-electric-blue font-thin">{item.diretoria} </span>
                            <span className="font-thin">- {item.funcao}</span>
                          </div>
                          <button className="mt-4">
                            <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" />
                            <span className="uppercase">Ver mais</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className={`flex justify-center ${page < 2 && 'hidden'}`}>
              <ReactPaginate
                activeClassName={'item active '}
                breakClassName={'item break-me '}
                breakLabel={'...'}
                containerClassName={'pagination'}
                disabledClassName={'disabled-page'}
                nextClassName={'item next '}
                pageClassName={'item pagination-page '}
                previousClassName={'item previous'}
                initialPage={0}
                forcePage={activePag}
                pageLinkClassName={'page-link'}
                nextLabel={<IoIosArrowForward style={{ fontSize: 18, width: 150 }} />}
                onPageChange={data => loadData(null, data.selected)}
                pageRangeDisplayed={3}
                pageCount={page}
                previousLabel={<IoIosArrowBack style={{ fontSize: 18, width: 150 }} />}
                previousAriaLabel="Página anterior"
                nextAriaLabel="Próxima página"
              />
            </div>
          </Box>
        </div>
      </div>

      <Outlet />
    </>
  );
}
